<template>
    <div class="HomePage">
        <SiteHeader/>

        <SiteHero/>

        <Container>
            <SiteImgText
                tag="easy"
                title="Manage your drivers and projects digitally."
                description="Managers can view submitted tickets and easily manage clients, projects, tickets, drivers, trucks and trailers all in one place."
                img="/img/home/dashboard.png"
                class="shadow"
            />

            <SiteImgText
                tag="simple"
                title="Real-time reporting."
                description="Generate presentable hauling tickets instantly in industry format. Export a number of different reports in Excel or PDF."
                img="/img/home/hauling-sheet-example.svg"
                class="shadow reverse"
            >
                <ul>
                    <li>Hauling Sheets</li>
                    <li>Driver Timesheet Reports</li>
                    <li>Project Reports</li>
                    <li>Ticket Reports</li>
                </ul>
            </SiteImgText>
        </Container>

        <div class="section">
            <div class="sectionMain">
                <h2>Integrates with the DumpTek Mobile App for Drivers.</h2>
                <p>Mobile app built specifically for drivers and syncs with your DumpTek management system. Seamlessly works across all of your devices and available on Apple Store and Google Play.</p>
            </div>

            <AppStoreBadges/>

            <div class="sectionImg" style="background-image: url(/img/home/multiple-devices.jpg)"/>
        </div>

        <Container>
            <SiteImgText
                tag="flexible"
                title="Track project revenues."
                description="Set hourly rates for each project or input individual rates per material or load or tons. DumpTek automatically calculates revenue for each hauling ticket submitted."
                img="/img/home/project-rates.png"
                class="shadow"
            />

            <SiteImgText
                tag="improving"
                title="Automatic updates."
                description="DumpTek is always looking for ways to better serve your needs. New features are in development to further simplify your day-to-day operations and increase cash flow."
                img="/img/home/automatic-updates.png"
                class="reverse"
            />
        </Container>

        <SiteCallToAction/>

        <SiteFooter/>
    </div>
</template>

<script>
import AppStoreBadges from '@/components/AppStoreBadges';
import SiteHeader from './components/SiteHeader';
import SiteFooter from './components/SiteFooter';
import SiteHero from './components/SiteHero';
import SiteImgText from './components/SiteImgText';
import SiteCallToAction from './components/SiteCallToAction';

export default {
    name: 'HomePage',

    components: {
        AppStoreBadges,
        SiteHeader,
        SiteFooter,
        SiteHero,
        SiteImgText,
        SiteCallToAction,
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.HomePage {
    .SiteHero {
        margin-bottom: 20px;
    }

    .section {
        text-align: center;

        .sectionMain {
            max-width: 700px;
            margin: 60px auto 30px;

            h2 {
                @extend %display-subtitle;
                margin: 30px 0;
            }

            p {
                @extend %display-description;
            }
        }

        .sectionImg {
            @include aspect-ratio(16, 9);
            background-size: cover;
            background-position: center;
        }
    }

    .AppStoreBadges {
        margin-bottom: 40px;
    }

    .SiteImgText {
        ::v-deep img {
            max-width: 500px;
        }

        ul {
            @extend %display-description;
            margin-top: $grid-gutter-width;
            padding-left: 30px;
            list-style: inside;
            text-align: left;
        }

        @include breakpoint(lg) {
            ::v-deep .main {
                padding-left: 30px;
            }

            &.reverse ::v-deep .main {
                padding-left: 0;
                padding-right: 30px;
            }
        }

        @include breakpoint(md) {
            ::v-deep .main {
                padding-left: 0;
                padding-right: 0;
            }
        }
    }
}
</style>
